import React, { useEffect, useState } from "react";
import { getConnections, notInterested, removeConnection } from "../api/api";
import { useNavigate } from "react-router-dom";
import { environment } from "../../environments/environments";
import "./Connection.css";
import userIcon from "../../assets/images/user-icon.png";
import Swal from "sweetalert2";

const Connection = () => {
  const [allUser, setAllUser] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currUser, setCurrUser] = useState(null);
  const navigate = useNavigate();

  const fetchUserData = async () => {
    console.log("fetchUserData_function");
    setIsLoading(true);
    try {
      const userData = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userData);
      setCurrUser(parsedUserData);

      const currentUserId = parsedUserData?.id || parsedUserData?._id;
      if (currentUserId) {
        const connectionData = await getConnections({ user_id: currentUserId });
        const allConnections = connectionData?.data || [];

        const filtered = allConnections.filter((req) => {
          const fromId = req?.from_user?.id || req?.from_user?._id;
          const toId = req?.to_user?.id || req?.to_user?._id;
          return fromId === currentUserId || toId === currentUserId;
        });
        console.log("apie value", JSON.stringify(filtered));
        setAllUser(filtered);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  // const handleRemoveConnection = async (otherUserId) => {
  //   if (!window.confirm("Are you sure you want to remove this connection?"))
  //     return;

  //   setIsLoading(true);
  //   try {
  // const userData = localStorage.getItem("currentUser");
  // const parsedUserData = JSON.parse(userData);
  // const currentUserId = parsedUserData?.id || parsedUserData?._id;

  //     const value = { user_id: currentUserId, target_user_id: otherUserId };
  //     await removeConnection(value);
  //     await fetchUserData();
  //   } catch (error) {
  //     console.error("Error removing connection:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // const handleRemoveConnection = async (otherUserId) => {
  //   try {
  //     const userData = localStorage.getItem("currentUser");
  //     const parsedUserData = JSON.parse(userData);
  //     const currentUserId = parsedUserData?.id || parsedUserData?._id;
  //     const res = await notInterested({
  //       user_id: currentUserId,
  //       target_user_id: otherUserId,
  //     });
  //     if (res.success) {
  //       Swal.fire("Done", res.message, "success");
  //       setIsMemberNotInterested(true);
  //       fetchUserData();
  //     } else {
  //       Swal.fire("Error", res.message, "error");
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     Swal.fire("Error", "Something went wrong", "error");
  //   }
  // };

  const handleRemoveConnection = async (otherUserId) => {
    try {
      const userData = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userData);
      const currentUserId = parsedUserData?.id || parsedUserData?._id;
      const res = await notInterested({
        user_id: currentUserId,
        target_user_id: otherUserId,
      });
      console.log("notInterest_api_response", JSON.stringify(res));
      if (res.success) {
        Swal.fire("Done", res.message, "success");
        fetchUserData();
      } else {
        Swal.fire("Failed", res.message, "error");
      }
    } catch (err) {
      console.error("Error removing connection:", err);
      Swal.fire("Failed", "Something went wrong", "error");
    }
  };

  const handleChat = (userData) => {
    if (userData?.approve_reject_new_image === "pending") {
      Swal.fire({
        icon: "info",
        title: "Pending Profile",
        text: "This user profile is still pending. Please try again later.",
      });
    } else {
      navigate(`/Sidebar/chat/${userData?.id}`);
    }
  };

  return (
    <div className="connection-wrapper">
      {isLoading ? (
        <div className="connection-loader"></div>
      ) : allUser?.length > 0 ? (
        allUser?.map((user, index) => {
          const fromId = user?.from_user?.id || user?.from_user?._id;
          const isCurrentUserSender =
            fromId === currUser?.id || fromId === currUser?._id;
          const otherUser = isCurrentUserSender
            ? user?.to_user
            : user?.from_user;
          const otherUserId = otherUser?.id || otherUser?._id;

          const imageUri =
            otherUser?.pre_consent_for_displaying_images &&
            otherUser?.more_images?.[0]
              ? `${environment.url}/uploads/users/${otherUser.more_images[0]}`
              : userIcon;

          return (
            <div className="connection-card" key={index}>
              <img
                src={imageUri}
                alt={otherUser?.name}
                className="connection-image"
              />
              <div className="connection-info">
                <h3 className="connection-name">{otherUser?.name}</h3>
              </div>

              {user?.status === "0" ? (
                <div className="connection-btn pending">Pending</div>
              ) : (
                <div className="connection-actions">
                  <button
                    className="connection-btn chat"
                    onClick={() => handleChat(otherUser)}
                  >
                    💬 Chat
                  </button>
                  <button
                    className="connection-btn remove"
                    onClick={() => handleRemoveConnection(otherUserId)}
                  >
                    🗑️ Remove
                  </button>
                </div>
              )}
            </div>
          );
        })
      ) : (
        <div className="connection-no-data">No Connections Available</div>
      )}
    </div>
  );
};

export default Connection;
